'use strict';

exports.__esModule = true;
var UrlUpdateTypes = {
  replace: 'replace',
  replaceIn: 'replaceIn',
  multiReplaceIn: 'multiReplaceIn',
  push: 'push',
  pushIn: 'pushIn',
  multiPushIn: 'multiPushIn'
};

exports.default = UrlUpdateTypes;


//////////////////
// WEBPACK FOOTER
// ./~/react-url-query/lib/UrlUpdateTypes.js
// module id = 19
// module chunks = 231608221292675 249491790366547